import React from 'react';
import { AddComment, AssignmentInd, ChevronRight, FileDownload, LockReset, Numbers, PersonAdd, PowerSettingsNew, PriceChange, TaskAlt, Visibility } from '@mui/icons-material';
import { Edit } from './action-buttons/Edit';
import { SendMailIcon } from './action-buttons/SendMailIcon';
import { TrashcanIcon } from './action-buttons/TrashcanIcon';

// One icon per action, for the buttons in a table's row option cell. Those render as an icon with the label in a
// tooltip (see row-options-context), so the icon is the only thing naming the action - the same action drawn two
// ways in two tables, or one icon standing for two actions, reads as a different feature to the user.
//
// Pick from here when adding a row option; add a key when the action is genuinely new, and check the icon is not
// already spoken for. Keys are the action, not the screen.
export const ROW_ACTION_ICON = {
  edit: <Edit yellowIcon={true} />,
  delete: <TrashcanIcon />,
  view: <Visibility />,
  download: <FileDownload />,
  navigate: <ChevronRight />,
  done: <TaskAlt />,
  comment: <AddComment />,
  changePrices: <PriceChange />,
  toggleActive: <PowerSettingsNew />,
  assignNumber: <Numbers />,
  assignUser: <PersonAdd />,
  assignProjects: <AssignmentInd />,
  resetPassword: <LockReset />,
  sendMail: <SendMailIcon />,
} as const;

export type RowActionIcon = keyof typeof ROW_ACTION_ICON;
